import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin, Tabs } from 'antd';
import {SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import UPM from '../../constants/urlPermissionMappings'
import {PAGE_SIZE_DEFAULT} from '../../constants/appConstant'
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
import history from '../../routes/history'
const storage = window.localStorage
const { TabPane } = Tabs;

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class MarketingSmsManagement extends Component {
  state = {
    type: this.props?.location?.state?.taskType || "1",
  }
  componentDidMount() {
    const {marketingSmsManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.handleSearch(this.state.type)
    marketingSmsManagementStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingSmsManagementStore.onGetSign({
      smsType: this.state.type,
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingSmsManagementStore.onGetStatus('taskStatus')
    marketingSmsManagementStore.onExpoAction()
  }
  handleSearch = (type) => {
    const {marketingSmsManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementStore.onSearchAction({
      smsType: type,
      marketGroupId: '',
      configName: '',
      signId: '',
      smsContent: '',
      expoResume: '',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    })
  }
  onChange = (value) => {
    this.setState({
      type: value
    })
    history.push(`/smsManagement`)
    this.handleSearch(value)
  }
  render() {
    const { marketingSmsManagementStore,location, t } = this.props
    const { isFetching } = marketingSmsManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <div className="searchFormTitle" style={{background: 'white', padding: '0 15px'}}>
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Tabs activeKey={this.state.type} onChange={this.onChange} className='messagesTabs marketingSmsTemplateTabs'>
            <TabPane tab={t(`marketingManagement.marketingSms`)} key="1">
              <SearchForm type={this.state.type} location={location} />
              <SearchResult type={this.state.type} />
            </TabPane>
            <TabPane tab={t(`marketingManagement.noticeSms`)} key="2">
              <SearchForm type={this.state.type} location={location} />
              <SearchResult type={this.state.type} />
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    );
  }
}
export default withTranslation()(MarketingSmsManagement)
